import { RandomId } from "@swivl-mono/helpers";

const NodeActionsHelper = {
  quickReply(text = "Button") {
    let replyId = RandomId(6);
    return {
      id: replyId,
      type: "reply",
      text: text,
      payload: replyId,
      onSelectGoto: null
    } as any;
  },
  postback(text = "Button") {
    let id = RandomId(6);
    return {
      id: id,
      type: "postback",
      text: text,
      payload: id,
      onSelectGoto: null
    } as any;
  }
};
export default NodeActionsHelper;
